import * as React from "react";
import { NavItem as BootstrapNavItem } from "react-bootstrap";
import NavItemStateIndicator from "components/common/NavItemStateIndicator";
const NavItem = ({ children = void 0, ...props }) => /* @__PURE__ */ React.createElement(BootstrapNavItem, { ...props }, /* @__PURE__ */ React.createElement(NavItemStateIndicator, null, children));
NavItem.displayName = "NavItem";
export default NavItem;
